import { render, staticRenderFns } from "./RegisterTongJ.vue?vue&type=template&id=2a8c602c&scoped=true"
import script from "./RegisterTongJ.vue?vue&type=script&lang=js"
export * from "./RegisterTongJ.vue?vue&type=script&lang=js"
import style0 from "./RegisterTongJ.vue?vue&type=style&index=0&id=2a8c602c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c602c",
  null
  
)

export default component.exports